import React from 'react';
import Info from '../../info';

const RightPanel = (props) => {
  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull ';
  if (props.deletedRoleIds && props.deletedRoleIds.length == 0) {
    saveClasses += props.disabledClass;
  }
  let cancelClasses =
    'ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull';
  return (
    <div>
      <div className="mrtxxs mrbl max-width">
        <button type="button" onClick={props.handleSave} className={saveClasses}>
          {APP.LANGUAGE.Delete}
          <i className="trash icon" />
        </button>
        <button type="button" onClick={props.cancelUpdateMyRole} className={cancelClasses}>
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>

      {!!props.isViewingOthers ? (
        <Info
          paragraphs={[
            APP.LANGUAGE.MyRoles.OtherUserRolesText1.replace('##selectedUserName##', props.selectedUserName),
            APP.LANGUAGE.MyRoles.OtherUserRolesText2,
          ]}
        />
      ) : (
        <Info
          paragraphs={[
            APP.LANGUAGE.MyRoles.InfoText1.replace('##PortalName##', window.APP.CONFIGURATION.PORTAL.Name),
            APP.LANGUAGE.MyRoles.InfoText2.replace('##PortalName##', window.APP.CONFIGURATION.PORTAL.Name),
          ]}
        />
      )}
    </div>
  );
};

export default RightPanel;
